// Auto-generated by backend/generate_legal.py — privacy policy, account deletion & legal links (11 languages).
export const PRIVACY_UI = {
  "title": {
    "id": "Kebijakan Privasi Manasik",
    "en": "Manasik Privacy Policy",
    "ar": "سياسة خصوصية مناسك",
    "fr": "Politique de confidentialité de Manasik",
    "de": "Manasik Datenschutzrichtlinie",
    "es": "Política de privacidad de Manasik",
    "ru": "Политика конфиденциальности Manasik",
    "zh": "朝觐礼仪隐私政策",
    "ja": "Manasikプライバシーポリシー",
    "ko": "Manasik 개인정보 처리방침",
    "hi": "मनासिक गोपनीयता नीति"
  },
  "updated": {
    "id": "Terakhir diperbarui: {date}",
    "en": "Last updated: {date}",
    "ar": "آخر تحديث: {date}",
    "fr": "Dernière mise à jour : {date}",
    "de": "Zuletzt aktualisiert: {date}",
    "es": "Última actualización: {date}",
    "ru": "Последнее обновление: {date}",
    "zh": "最后更新：{date}",
    "ja": "最終更新日：{date}",
    "ko": "마지막 업데이트: {date}",
    "hi": "अंतिम अपडेट: {date}"
  },
  "intro": {
    "id": "Manasik (\"kami\") menghargai privasi Anda. Kebijakan ini menjelaskan data apa yang kami kumpulkan saat Anda menggunakan aplikasi web dan aplikasi Android Manasik ({domain}), bagaimana kami menggunakannya, dan pilihan yang Anda miliki.",
    "en": "Manasik (\"we\") respects your privacy. This policy explains what data we collect when you use the Manasik web app and Android app ({domain}), how we use it, and the choices you have.",
    "ar": "مناسك (\"نحن\") تحترم خصوصيتك. توضح هذه السياسة البيانات التي نجمعها عند استخدامك تطبيق مناسك على الويب وتطبيق الأندرويد ({domain})، وكيفية استخدامها، والخيارات المتاحة لك.",
    "fr": "Manasik (« nous ») respecte votre vie privée. Cette politique explique quelles données nous collectons lorsque vous utilisez l'application web et l'application Android Manasik ({domain}), comment nous les utilisons, et les choix dont vous disposez.",
    "de": "Manasik („wir\") respektiert Ihre Privatsphäre. Diese Richtlinie erläutert, welche Daten wir erfassen, wenn Sie die Manasik-Web-App und Android-App ({domain}) nutzen, wie wir diese verwenden und welche Wahlmöglichkeiten Sie haben.",
    "es": "Manasik (\"nosotros\") respeta su privacidad. Esta política explica qué datos recopilamos cuando utiliza la aplicación web y la aplicación Android de Manasik ({domain}), cómo los usamos y las opciones que tiene.",
    "ru": "Manasik («мы») уважает вашу конфиденциальность. Эта политика объясняет, какие данные мы собираем при использовании вами веб-приложения и Android-приложения Manasik ({domain}), как мы их используем и какие у вас есть возможности выбора.",
    "zh": "Manasik（\"我们\"）尊重您的隐私。本政策说明您在使用 Manasik 网页应用及 Android 应用（{domain}）时我们收集哪些数据、如何使用这些数据，以及您拥有哪些选择权。",
    "ja": "Manasik（「当社」）はあなたのプライバシーを尊重します。このポリシーでは、ManasikのWebアプリおよびAndroidアプリ（{domain}）をご利用の際に収集するデータ、その利用方法、およびお客様の選択肢について説明します。",
    "ko": "Manasik(\"당사\")는 귀하의 개인정보를 존중합니다. 이 정책은 귀하가 Manasik 웹 앱 및 Android 앱({domain})을 사용할 때 수집하는 데이터, 그 사용 방법, 그리고 귀하가 가진 선택권을 설명합니다.",
    "hi": "Manasik (\"हम\") आपकी गोपनीयता का सम्मान करता है। यह नीति बताती है कि जब आप Manasik वेब ऐप और Android ऐप ({domain}) का उपयोग करते हैं तो हम कौन-सा डेटा एकत्र करते हैं, उसका उपयोग कैसे करते हैं, और आपके पास क्या विकल्प हैं।"
  },
  "summaryTitle": {
    "id": "Ringkasan",
    "en": "Summary",
    "ar": "ملخص",
    "fr": "Résumé",
    "de": "Zusammenfassung",
    "es": "Resumen",
    "ru": "Краткое изложение",
    "zh": "摘要",
    "ja": "概要",
    "ko": "요약",
    "hi": "सारांश"
  },
  "summary1": {
    "id": "Tanpa iklan, tanpa pelacak iklan, data Anda tidak dijual.",
    "en": "No ads, no ad trackers, your data is not sold.",
    "ar": "لا إعلانات، ولا أدوات تتبع إعلانية، ولا يُباع بياناتك.",
    "fr": "Pas de publicités, pas de traceurs publicitaires, vos données ne sont pas vendues.",
    "de": "Keine Werbung, keine Werbe-Tracker, Ihre Daten werden nicht verkauft.",
    "es": "Sin anuncios, sin rastreadores de anuncios, sus datos no se venden.",
    "ru": "Никакой рекламы, никаких рекламных трекеров, ваши данные не продаются.",
    "zh": "无广告、无广告追踪器，您的数据不会被出售。",
    "ja": "広告なし、広告トラッカーなし、お客様のデータは販売されません。",
    "ko": "광고 없음, 광고 추적기 없음, 귀하의 데이터는 판매되지 않습니다.",
    "hi": "कोई विज्ञापन नहीं, कोई विज्ञापन ट्रैकर नहीं, आपका डेटा बेचा नहीं जाता।"
  },
  "summary2": {
    "id": "Lokasi hanya diproses di perangkat dengan izin Anda.",
    "en": "Location is processed only on your device, with your permission.",
    "ar": "لا تتم معالجة بيانات الموقع إلا على جهازك، وبإذنك.",
    "fr": "La localisation est traitée uniquement sur votre appareil, avec votre autorisation.",
    "de": "Der Standort wird nur auf Ihrem Gerät und mit Ihrer Erlaubnis verarbeitet.",
    "es": "La ubicación se procesa únicamente en su dispositivo, con su permiso.",
    "ru": "Местоположение обрабатывается только на вашем устройстве и с вашего разрешения.",
    "zh": "位置信息仅在您的设备上处理，且需获得您的许可。",
    "ja": "位置情報はお客様の許可のもと、お客様のデバイス上でのみ処理されます。",
    "ko": "위치 정보는 귀하의 허락 하에 귀하의 기기에서만 처리됩니다.",
    "hi": "स्थान की जानकारी केवल आपकी अनुमति से आपके डिवाइस पर ही संसाधित की जाती है।"
  },
  "summary3": {
    "id": "Anda bisa menghapus akun dan seluruh data kapan saja dari halaman Profil.",
    "en": "You can delete your account and all data at any time from the Profile page.",
    "ar": "يمكنك حذف حسابك وجميع بياناتك في أي وقت من صفحة الملف الشخصي.",
    "fr": "Vous pouvez supprimer votre compte et toutes vos données à tout moment depuis la page Profil.",
    "de": "Sie können Ihr Konto und alle Daten jederzeit über die Profilseite löschen.",
    "es": "Puede eliminar su cuenta y todos los datos en cualquier momento desde la página de Perfil.",
    "ru": "Вы можете удалить свою учётную запись и все данные в любое время на странице Профиля.",
    "zh": "您可以随时从个人资料页面删除账户及所有数据。",
    "ja": "プロフィールページからいつでもアカウントとすべてのデータを削除できます。",
    "ko": "프로필 페이지에서 언제든지 계정과 모든 데이터를 삭제할 수 있습니다.",
    "hi": "आप किसी भी समय प्रोफ़ाइल पृष्ठ से अपना खाता और सभी डेटा हटा सकते हैं।"
  }
};

export const PRIVACY_SECTIONS = [
  {
    "h": {
      "id": "1. Data yang kami kumpulkan",
      "en": "1. Data We Collect",
      "ar": "١. البيانات التي نجمعها",
      "fr": "1. Données que nous collectons",
      "de": "1. Daten, die wir erheben",
      "es": "1. Datos que recopilamos",
      "ru": "1. Данные, которые мы собираем",
      "zh": "1. 我们收集的数据",
      "ja": "1. 収集するデータ",
      "ko": "1. 수집하는 데이터",
      "hi": "1. हम जो डेटा एकत्र करते हैं"
    },
    "p": [
      {
        "id": "Data akun: alamat email, nama, dan kata sandi (disimpan hanya sebagai hash bcrypt) saat Anda mendaftar. Foto profil bersifat opsional.",
        "en": "Account data: email address, name, and password (stored only as a bcrypt hash) when you register. Profile photo is optional.",
        "ar": "بيانات الحساب: عنوان البريد الإلكتروني، والاسم، وكلمة المرور (المخزَّنة فقط كـ hash بصيغة bcrypt) عند التسجيل. صورة الملف الشخصي اختيارية.",
        "fr": "Données de compte : adresse e-mail, nom et mot de passe (stocké uniquement sous forme de hash bcrypt) lors de votre inscription. La photo de profil est facultative.",
        "de": "Kontodaten: E-Mail-Adresse, Name und Passwort (nur als bcrypt-Hash gespeichert) bei der Registrierung. Das Profilfoto ist optional.",
        "es": "Datos de cuenta: dirección de correo electrónico, nombre y contraseña (almacenada únicamente como hash bcrypt) al registrarse. La foto de perfil es opcional.",
        "ru": "Данные учётной записи: адрес электронной почты, имя и пароль (хранится только в виде bcrypt-хэша) при регистрации. Фото профиля не является обязательным.",
        "zh": "账户数据：注册时的电子邮件地址、姓名和密码（仅以 bcrypt 哈希值存储）。头像为可选项。",
        "ja": "アカウントデータ：登録時のメールアドレス、氏名、パスワード（bcryptハッシュとしてのみ保存）。プロフィール写真は任意です。",
        "ko": "계정 데이터: 가입 시 이메일 주소, 이름, 비밀번호(bcrypt 해시로만 저장). 프로필 사진은 선택 사항입니다.",
        "hi": "खाता डेटा: पंजीकरण के समय ईमेल पता, नाम और पासवर्ड (केवल bcrypt हैश के रूप में संग्रहीत)। प्रोफ़ाइल फ़ोटो वैकल्पिक है।"
      },
      {
        "id": "Data ibadah yang Anda buat: progres manasik, checklist, catatan, penanda, jurnal foto ziyarah, statistik ibadah, pengingat, dan pengaturan (bahasa, qari, metode waktu salat). Data ini disimpan agar tersinkron antar perangkat Anda.",
        "en": "Worship data you create: manasik progress, checklists, notes, bookmarks, ziyarah photo journals, worship statistics, reminders, and settings (language, qari, prayer time method). This data is stored to sync across your devices.",
        "ar": "بيانات العبادة التي تنشئها: تقدُّم المناسك، وقوائم المراجعة، والملاحظات، والإشارات المرجعية، ومجلات صور الزيارة، وإحصائيات العبادة، والتذكيرات، والإعدادات (اللغة، والقارئ، وطريقة مواقيت الصلاة). تُخزَّن هذه البيانات لتتزامن عبر أجهزتك.",
        "fr": "Données de culte que vous créez : progression des manasik, listes de contrôle, notes, signets, journaux photos de ziyarah, statistiques de culte, rappels et paramètres (langue, qari, méthode de calcul des horaires de prière). Ces données sont stockées pour se synchroniser sur vos appareils.",
        "de": "Von Ihnen erstellte Ibadah-Daten: Manasik-Fortschritt, Checklisten, Notizen, Lesezeichen, Ziyarah-Fotojournale, Ibadah-Statistiken, Erinnerungen und Einstellungen (Sprache, Qari, Gebetszeitenmethode). Diese Daten werden gespeichert, um sie geräteübergreifend zu synchronisieren.",
        "es": "Datos de ibadah que usted crea: progreso de manasik, listas de verificación, notas, marcadores, diarios fotográficos de ziyarah, estadísticas de ibadah, recordatorios y configuraciones (idioma, qari, método de horario de oración). Estos datos se almacenan para sincronizarse entre sus dispositivos.",
        "ru": "Данные об ибадах, которые вы создаёте: прогресс манасика, чек-листы, заметки, закладки, фотодневники зиярата, статистика ибадов, напоминания и настройки (язык, кари, метод времени намаза). Эти данные хранятся для синхронизации между вашими устройствами.",
        "zh": "您创建的功修数据：朝觐功课（manasik）进度、清单、笔记、书签、探访（ziyarah）照片日记、功修统计、提醒及设置（语言、诵经师、礼拜时间计算方法）。这些数据将被存储以在您的设备间同步。",
        "ja": "あなたが作成するイバーダーデータ：マナーシクの進捗、チェックリスト、メモ、ブックマーク、ズィヤーラ写真日記、イバーダー統計、リマインダー、設定（言語、カーリ、礼拝時間計算方法）。このデータはデバイス間で同期するために保存されます。",
        "ko": "사용자가 생성한 이바다 데이터: 마나식 진행 상황, 체크리스트, 메모, 북마크, 지야라 사진 일기, 이바다 통계, 알림 및 설정(언어, 카리, 예배 시간 방법). 이 데이터는 기기 간 동기화를 위해 저장됩니다.",
        "hi": "आपके द्वारा बनाया गया इबादत डेटा: मनासिक प्रगति, चेकलिस्ट, नोट्स, बुकमार्क, ज़ियारह फ़ोटो जर्नल, इबादत आँकड़े, अनुस्मारक और सेटिंग्स (भाषा, क़ारी, नमाज़ समय विधि)। यह डेटा आपके डिवाइसों के बीच सिंक करने के लिए संग्रहीत किया जाता है।"
      },
      {
        "id": "Lokasi: hanya diproses dengan izin Anda, di perangkat, untuk waktu salat, arah kiblat, cuaca, dan peta manasik. Server kami tidak menyimpan riwayat lokasi Anda; koordinat yang dibulatkan (±1 km) hanya dipakai sesaat untuk mengambil data cuaca.",
        "en": "Location: processed only with your permission, on-device, for prayer times, Qibla direction, weather, and manasik maps. Our servers do not store your location history; rounded coordinates (±1 km) are used only momentarily to retrieve weather data.",
        "ar": "الموقع الجغرافي: لا يُعالَج إلا بإذنك، على الجهاز نفسه، لأغراض مواقيت الصلاة، واتجاه القبلة، والطقس، وخرائط المناسك. لا تحتفظ خوادمنا بسجل مواقعك؛ وتُستخدَم الإحداثيات المقرَّبة (±١ كم) لفترة وجيزة فقط لجلب بيانات الطقس.",
        "fr": "Localisation : traitée uniquement avec votre autorisation, sur l'appareil, pour les horaires de prière, la direction de la Qibla, la météo et les cartes des manasik. Nos serveurs ne stockent pas votre historique de localisation ; des coordonnées arrondies (±1 km) sont utilisées momentanément pour récupérer les données météorologiques.",
        "de": "Standort: wird nur mit Ihrer Erlaubnis, auf dem Gerät verarbeitet, für Gebetszeiten, Qibla-Richtung, Wetter und Manasik-Karten. Unsere Server speichern keinen Standortverlauf; gerundete Koordinaten (±1 km) werden nur kurzzeitig zum Abrufen von Wetterdaten verwendet.",
        "es": "Ubicación: procesada únicamente con su permiso, en el dispositivo, para horarios de oración, dirección de la Qibla, el tiempo y mapas de manasik. Nuestros servidores no almacenan su historial de ubicación; las coordenadas redondeadas (±1 km) se usan solo momentáneamente para obtener datos meteorológicos.",
        "ru": "Местоположение: обрабатывается только с вашего разрешения, на устройстве, для времени намаза, направления Киблы, погоды и карт манасика. Наши серверы не хранят историю вашего местоположения; округлённые координаты (±1 км) используются лишь на мгновение для получения данных о погоде.",
        "zh": "位置：仅在您授权后于设备本地处理，用于礼拜时间、朝拜方向（Qibla）、天气及朝觐路线图。我们的服务器不存储您的位置历史；经过四舍五入的坐标（±1公里）仅在获取天气数据时短暂使用。",
        "ja": "位置情報：お客様の許可を得た場合のみ、デバイス上で処理され、礼拝時間、キブラの方向、天気、マナーシク地図に使用されます。当社のサーバーは位置情報の履歴を保存しません。丸められた座標（±1 km）は天気データの取得のためにのみ一時的に使用されます。",
        "ko": "위치: 기도 시간, 키블라 방향, 날씨, 마나식 지도를 위해 귀하의 허락 하에 기기에서만 처리됩니다. 당사 서버는 위치 기록을 저장하지 않으며, 반올림된 좌표(±1km)는 날씨 데이터를 가져오기 위해 잠시만 사용됩니다.",
        "hi": "स्थान: केवल आपकी अनुमति से, डिवाइस पर, नमाज़ के समय, क़िबला दिशा, मौसम और मनासिक मानचित्र के लिए संसाधित किया जाता है। हमारे सर्वर आपका स्थान इतिहास संग्रहीत नहीं करते; गोलाई वाले निर्देशांक (±1 किमी) केवल मौसम डेटा प्राप्त करने के लिए क्षण भर के लिए उपयोग किए जाते हैं।"
      },
      {
        "id": "Data teknis: alamat IP dan stempel waktu percobaan masuk untuk perlindungan dari serangan brute-force, serta token notifikasi push jika Anda mengaktifkan pengingat.",
        "en": "Technical data: IP address and timestamps of login attempts for protection against brute-force attacks, and push notification tokens if you enable reminders.",
        "ar": "البيانات التقنية: عنوان IP وطوابع وقت محاولات تسجيل الدخول للحماية من هجمات القوة الغاشمة (brute-force)، ورموز إشعارات الدفع (push notification tokens) إن قمتَ بتفعيل التذكيرات.",
        "fr": "Données techniques : adresse IP et horodatages des tentatives de connexion pour la protection contre les attaques par force brute, ainsi que les jetons de notification push si vous activez les rappels.",
        "de": "Technische Daten: IP-Adresse und Zeitstempel von Anmeldeversuchen zum Schutz vor Brute-Force-Angriffen sowie Push-Benachrichtigungstoken, wenn Sie Erinnerungen aktivieren.",
        "es": "Datos técnicos: dirección IP y marcas de tiempo de intentos de inicio de sesión para protección contra ataques de fuerza bruta, y tokens de notificación push si activa los recordatorios.",
        "ru": "Технические данные: IP-адрес и временны́е метки попыток входа для защиты от атак методом перебора (brute-force), а также токены push-уведомлений, если вы включили напоминания.",
        "zh": "技术数据：用于防范暴力破解攻击的IP地址和登录尝试时间戳，以及在您启用提醒时使用的推送通知令牌。",
        "ja": "技術データ：ブルートフォース攻撃対策のためのIPアドレスとログイン試行のタイムスタンプ、およびリマインダーを有効にした場合のプッシュ通知トークン。",
        "ko": "기술 데이터: 무차별 대입 공격(brute-force) 방지를 위한 IP 주소 및 로그인 시도 타임스탬프, 그리고 알림을 활성화한 경우 푸시 알림 토큰.",
        "hi": "तकनीकी डेटा: ब्रूट-फोर्स हमलों से सुरक्षा के लिए लॉगिन प्रयासों का IP पता और समय-स्टांप, और यदि आप अनुस्मारक सक्षम करते हैं तो पुश नोटिफिकेशन टोकन।"
      },
      {
        "id": "Kami tidak menampilkan iklan, tidak menggunakan pelacak iklan, dan tidak menjual data Anda.",
        "en": "We do not display ads, do not use ad trackers, and do not sell your data.",
        "ar": "نحن لا نعرض إعلانات، ولا نستخدم أدوات تتبع الإعلانات، ولا نبيع بياناتك.",
        "fr": "Nous n'affichons pas de publicités, n'utilisons pas de traceurs publicitaires et ne vendons pas vos données.",
        "de": "Wir zeigen keine Werbung an, verwenden keine Werbe-Tracker und verkaufen Ihre Daten nicht.",
        "es": "No mostramos anuncios, no utilizamos rastreadores de anuncios y no vendemos sus datos.",
        "ru": "Мы не показываем рекламу, не используем рекламные трекеры и не продаём ваши данные.",
        "zh": "我们不展示广告，不使用广告追踪器，也不出售您的数据。",
        "ja": "広告を表示せず、広告トラッカーを使用せず、お客様のデータを販売しません。",
        "ko": "저희는 광고를 표시하지 않으며, 광고 추적기를 사용하지 않고, 귀하의 데이터를 판매하지 않습니다.",
        "hi": "हम विज्ञापन प्रदर्शित नहीं करते, विज्ञापन ट्रैकर का उपयोग नहीं करते, और आपका डेटा नहीं बेचते।"
      }
    ]
  },
  {
    "h": {
      "id": "2. Bagaimana kami menggunakan data",
      "en": "2. How we use your data",
      "ar": "2. كيف نستخدم بياناتك",
      "fr": "2. Comment nous utilisons vos données",
      "de": "2. Wie wir Ihre Daten verwenden",
      "es": "2. Cómo utilizamos sus datos",
      "ru": "2. Как мы используем ваши данные",
      "zh": "2. 我们如何使用您的数据",
      "ja": "2. お客様のデータの利用方法",
      "ko": "2. 데이터 사용 방법",
      "hi": "2. हम आपका डेटा कैसे उपयोग करते हैं"
    },
    "p": [
      {
        "id": "Untuk menyediakan dan menyinkronkan fitur aplikasi, mengirim email verifikasi dan pengaturan ulang kata sandi, mengirim notifikasi pengingat yang Anda aktifkan, serta menjaga keamanan akun.",
        "en": "To provide and sync app features, send verification emails and password resets, send reminder notifications you have enabled, and keep your account secure.",
        "ar": "لتوفير ميزات التطبيق ومزامنتها، وإرسال رسائل التحقق وإعادة تعيين كلمة المرور، وإرسال إشعارات التذكير التي قمت بتفعيلها، والحفاظ على أمان حسابك.",
        "fr": "Pour fournir et synchroniser les fonctionnalités de l'application, envoyer des e-mails de vérification et de réinitialisation de mot de passe, envoyer les notifications de rappel que vous avez activées, et assurer la sécurité de votre compte.",
        "de": "Um App-Funktionen bereitzustellen und zu synchronisieren, Bestätigungs-E-Mails und Passwortzurücksetzungen zu senden, von Ihnen aktivierte Erinnerungsbenachrichtigungen zu versenden und die Sicherheit Ihres Kontos zu gewährleisten.",
        "es": "Para proporcionar y sincronizar las funciones de la aplicación, enviar correos electrónicos de verificación y restablecimiento de contraseña, enviar notificaciones de recordatorio que usted haya activado y mantener la seguridad de su cuenta.",
        "ru": "Для предоставления и синхронизации функций приложения, отправки писем для подтверждения и сброса пароля, отправки активированных вами напоминаний, а также обеспечения безопасности вашей учётной записи.",
        "zh": "用于提供和同步应用功能、发送验证邮件和密码重置邮件、发送您已启用的提醒通知，以及保护您账户的安全。",
        "ja": "アプリ機能の提供と同期、確認メールおよびパスワードリセットの送信、お客様が有効にしたリマインダー通知の送信、ならびにアカウントのセキュリティ維持のために使用します。",
        "ko": "앱 기능을 제공하고 동기화하며, 인증 이메일 및 비밀번호 재설정 이메일을 발송하고, 사용자가 활성화한 알림 메시지를 전송하며, 계정 보안을 유지하기 위해 사용합니다.",
        "hi": "ऐप की सुविधाएँ प्रदान करने और सिंक्रोनाइज़ करने, सत्यापन ईमेल और पासवर्ड रीसेट भेजने, आपके द्वारा सक्षम किए गए रिमाइंडर नोटिफिकेशन भेजने तथा आपके खाते को सुरक्षित रखने के लिए।"
      }
    ]
  },
  {
    "h": {
      "id": "3. Layanan pihak ketiga",
      "en": "3. Third-party services",
      "ar": "3. خدمات الطرف الثالث",
      "fr": "3. Services tiers",
      "de": "3. Drittanbieterdienste",
      "es": "3. Servicios de terceros",
      "ru": "3. Сторонние сервисы",
      "zh": "3. 第三方服务",
      "ja": "3. サードパーティサービス",
      "ko": "3. 제3자 서비스",
      "hi": "3. तृतीय-पक्ष सेवाएँ"
    },
    "p": [
      {
        "id": "Audio bacaan (text-to-speech): teks doa/zikir dikirim ke ElevenLabs untuk menghasilkan audio; hasilnya disimpan sementara (cache) di server kami. Tidak ada data pribadi yang dikirim.",
        "en": "Audio recitation (text-to-speech): du'a/dhikr text is sent to ElevenLabs to generate audio; the result is temporarily stored (cached) on our server. No personal data is transmitted.",
        "ar": "قراءة الصوت (تحويل النص إلى كلام): يتم إرسال نص الدعاء/الذكر إلى ElevenLabs لتوليد الصوت؛ ويُخزَّن الناتج مؤقتاً (كـ cache) على خادمنا. لا يتم إرسال أي بيانات شخصية.",
        "fr": "Audio de récitation (synthèse vocale) : le texte des du'a/dhikr est envoyé à ElevenLabs pour générer l'audio ; le résultat est temporairement stocké (mis en cache) sur notre serveur. Aucune donnée personnelle n'est transmise.",
        "de": "Audio-Rezitation (Text-zu-Sprache): Der Du'a-/Dhikr-Text wird zur Audiogenerierung an ElevenLabs gesendet; das Ergebnis wird vorübergehend (als Cache) auf unserem Server gespeichert. Es werden keine persönlichen Daten übertragen.",
        "es": "Audio de recitación (texto a voz): el texto del du'a/dhikr se envía a ElevenLabs para generar el audio; el resultado se almacena temporalmente (en caché) en nuestro servidor. No se transmite ningún dato personal.",
        "ru": "Аудиочтение (синтез речи): текст ду'а/зикра отправляется в ElevenLabs для генерации аудио; результат временно сохраняется (кэшируется) на нашем сервере. Личные данные не передаются.",
        "zh": "诵读音频（文字转语音）：祈祷/念诵文本被发送至 ElevenLabs 以生成音频；生成结果临时存储（缓存）于我们的服务器上。不会传输任何个人数据。",
        "ja": "朗読音声（テキスト読み上げ）：ドゥアー/ズィクルのテキストが音声生成のために ElevenLabs に送信され、その結果は当社サーバーに一時的に保存（キャッシュ）されます。個人データは送信されません。",
        "ko": "낭독 오디오(텍스트 음성 변환): 두아/지크르 텍스트가 오디오 생성을 위해 ElevenLabs로 전송되며, 그 결과는 당사 서버에 임시로 저장(캐시)됩니다. 개인 데이터는 전송되지 않습니다.",
        "hi": "पाठ ऑडियो (टेक्स्ट-टू-स्पीच): दुआ/ज़िक्र का टेक्स्ट ऑडियो उत्पन्न करने के लिए ElevenLabs को भेजा जाता है; परिणाम हमारे सर्वर पर अस्थायी रूप से संग्रहीत (कैश) किया जाता है। कोई व्यक्तिगत डेटा प्रेषित नहीं किया जाता।"
      },
      {
        "id": "Cuaca: koordinat yang dibulatkan dikirim ke Open-Meteo. Peta dan nama lokasi: OpenStreetMap, Nominatim, dan Photon (Komoot). Email transaksional dikirim melalui penyedia email kami. Aplikasi Android berjalan di atas Google Chrome (Trusted Web Activity) dan tunduk pada kebijakan privasi Google Chrome.",
        "en": "Weather: rounded coordinates are sent to Open-Meteo. Maps and location names: OpenStreetMap, Nominatim, and Photon (Komoot). Transactional emails are sent through our email provider. The Android app runs on Google Chrome (Trusted Web Activity) and is subject to Google Chrome's privacy policy.",
        "ar": "الطقس: يتم إرسال إحداثيات مقرَّبة إلى Open-Meteo. الخرائط وأسماء المواقع: OpenStreetMap وNominatim وPhoton (Komoot). تُرسَل رسائل البريد الإلكتروني التعاملية عبر مزود البريد الإلكتروني لدينا. يعمل تطبيق Android على Google Chrome (Trusted Web Activity) ويخضع لسياسة خصوصية Google Chrome.",
        "fr": "Météo : des coordonnées arrondies sont envoyées à Open-Meteo. Cartes et noms de lieux : OpenStreetMap, Nominatim et Photon (Komoot). Les e-mails transactionnels sont envoyés via notre fournisseur de messagerie. L'application Android fonctionne sur Google Chrome (Trusted Web Activity) et est soumise à la politique de confidentialité de Google Chrome.",
        "de": "Wetter: Gerundete Koordinaten werden an Open-Meteo gesendet. Karten und Ortsnamen: OpenStreetMap, Nominatim und Photon (Komoot). Transaktions-E-Mails werden über unseren E-Mail-Anbieter versendet. Die Android-App läuft auf Google Chrome (Trusted Web Activity) und unterliegt der Datenschutzrichtlinie von Google Chrome.",
        "es": "Clima: se envían coordenadas redondeadas a Open-Meteo. Mapas y nombres de ubicaciones: OpenStreetMap, Nominatim y Photon (Komoot). Los correos electrónicos transaccionales se envían a través de nuestro proveedor de correo electrónico. La aplicación Android se ejecuta sobre Google Chrome (Trusted Web Activity) y está sujeta a la política de privacidad de Google Chrome.",
        "ru": "Погода: округлённые координаты отправляются в Open-Meteo. Карты и названия мест: OpenStreetMap, Nominatim и Photon (Komoot). Транзакционные письма отправляются через нашего почтового провайдера. Приложение для Android работает на основе Google Chrome (Trusted Web Activity) и подчиняется политике конфиденциальности Google Chrome.",
        "zh": "天气：经过取整的坐标发送至 Open-Meteo。地图和地点名称：OpenStreetMap、Nominatim 和 Photon（Komoot）。事务性邮件通过我们的电子邮件服务商发送。Android 应用运行于 Google Chrome（受信任的网络活动），并受 Google Chrome 隐私政策的约束。",
        "ja": "天気：丸めた座標が Open-Meteo に送信されます。地図と場所名：OpenStreetMap、Nominatim、および Photon（Komoot）。トランザクションメールは当社のメールプロバイダーを通じて送信されます。Android アプリは Google Chrome（Trusted Web Activity）上で動作し、Google Chrome のプライバシーポリシーに従います。",
        "ko": "날씨: 반올림된 좌표가 Open-Meteo로 전송됩니다. 지도 및 위치 이름: OpenStreetMap, Nominatim, Photon(Komoot). 트랜잭션 이메일은 당사 이메일 제공업체를 통해 발송됩니다. Android 앱은 Google Chrome(Trusted Web Activity) 위에서 실행되며 Google Chrome의 개인정보 보호정책의 적용을 받습니다.",
        "hi": "मौसम: Open-Meteo को गोल किए गए निर्देशांक भेजे जाते हैं। मानचित्र और स्थान के नाम: OpenStreetMap, Nominatim और Photon (Komoot)। लेन-देन संबंधी ईमेल हमारे ईमेल प्रदाता के माध्यम से भेजे जाते हैं। Android ऐप Google Chrome (Trusted Web Activity) पर चलता है और Google Chrome की गोपनीयता नीति के अधीन है।"
      }
    ]
  },
  {
    "h": {
      "id": "4. Penyimpanan dan keamanan",
      "en": "4. Storage and Security",
      "ar": "4. التخزين والأمان",
      "fr": "4. Stockage et sécurité",
      "de": "4. Speicherung und Sicherheit",
      "es": "4. Almacenamiento y seguridad",
      "ru": "4. Хранение и безопасность",
      "zh": "4. 存储与安全",
      "ja": "4. ストレージとセキュリティ",
      "ko": "4. 저장 및 보안",
      "hi": "4. भंडारण और सुरक्षा"
    },
    "p": [
      {
        "id": "Semua lalu lintas dienkripsi (HTTPS). Kata sandi di-hash dengan bcrypt, sesi memakai cookie httpOnly dengan rotasi token, dan akses ke data dibatasi per akun. Foto disimpan di penyimpanan objek dan hanya bisa diakses oleh pemiliknya.",
        "en": "All traffic is encrypted (HTTPS). Passwords are hashed with bcrypt, sessions use httpOnly cookies with token rotation, and access to data is restricted per account. Photos are stored in object storage and can only be accessed by their owner.",
        "ar": "يتم تشفير جميع حركة البيانات (HTTPS). يتم تجزئة كلمات المرور باستخدام bcrypt، وتستخدم الجلسات ملفات تعريف ارتباط httpOnly مع تدوير الرموز المميزة، ويقتصر الوصول إلى البيانات على كل حساب. يتم تخزين الصور في مستودع الكائنات ولا يمكن الوصول إليها إلا من قِبَل مالكها.",
        "fr": "Tout le trafic est chiffré (HTTPS). Les mots de passe sont hachés avec bcrypt, les sessions utilisent des cookies httpOnly avec rotation de jeton, et l'accès aux données est restreint par compte. Les photos sont stockées dans un stockage d'objets et ne sont accessibles que par leur propriétaire.",
        "de": "Der gesamte Datenverkehr ist verschlüsselt (HTTPS). Passwörter werden mit bcrypt gehasht, Sitzungen verwenden httpOnly-Cookies mit Token-Rotation, und der Datenzugriff ist auf das jeweilige Konto beschränkt. Fotos werden im Objektspeicher gespeichert und sind nur für den jeweiligen Inhaber zugänglich.",
        "es": "Todo el tráfico está cifrado (HTTPS). Las contraseñas se cifran con bcrypt, las sesiones usan cookies httpOnly con rotación de tokens, y el acceso a los datos está restringido por cuenta. Las fotos se almacenan en almacenamiento de objetos y solo el propietario puede acceder a ellas.",
        "ru": "Весь трафик шифруется (HTTPS). Пароли хэшируются с помощью bcrypt, сессии используют httpOnly-куки с ротацией токенов, а доступ к данным ограничен учётной записью. Фотографии хранятся в объектном хранилище и доступны только их владельцу.",
        "zh": "所有流量均经过加密（HTTPS）。密码使用 bcrypt 进行哈希处理，会话使用带有令牌轮换的 httpOnly Cookie，数据访问按账户进行限制。照片存储在对象存储中，仅限其所有者访问。",
        "ja": "すべての通信は暗号化されています（HTTPS）。パスワードはbcryptでハッシュ化され、セッションはトークンローテーション付きのhttpOnly Cookieを使用し、データへのアクセスはアカウントごとに制限されています。写真はオブジェクトストレージに保存され、所有者のみがアクセスできます。",
        "ko": "모든 트래픽은 암호화됩니다(HTTPS). 비밀번호는 bcrypt로 해시 처리되고, 세션은 토큰 순환 방식의 httpOnly 쿠키를 사용하며, 데이터 접근은 계정별로 제한됩니다. 사진은 객체 스토리지에 저장되며 소유자만 접근할 수 있습니다.",
        "hi": "सभी ट्रैफ़िक एन्क्रिप्टेड (HTTPS) है। पासवर्ड को bcrypt से हैश किया जाता है, सत्र टोकन रोटेशन के साथ httpOnly कुकीज़ का उपयोग करते हैं, और डेटा तक पहुँच प्रत्येक खाते तक सीमित है। फ़ोटो ऑब्जेक्ट स्टोरेज में संग्रहीत की जाती हैं और केवल उनके स्वामी द्वारा ही एक्सेस की जा सकती हैं।"
      },
      {
        "id": "Data disimpan selama akun Anda aktif. Token verifikasi, cache cuaca, dan data sementara lainnya dihapus otomatis setelah masa berlakunya berakhir.",
        "en": "Data is stored for as long as your account is active. Verification tokens, weather cache, and other temporary data are automatically deleted after they expire.",
        "ar": "تُحفظ البيانات طوال فترة نشاط حسابك. يتم حذف رموز التحقق وذاكرة التخزين المؤقت للطقس والبيانات المؤقتة الأخرى تلقائيًا بعد انتهاء صلاحيتها.",
        "fr": "Les données sont conservées tant que votre compte est actif. Les jetons de vérification, le cache météo et les autres données temporaires sont automatiquement supprimés après leur expiration.",
        "de": "Daten werden gespeichert, solange Ihr Konto aktiv ist. Verifizierungstoken, Wetter-Cache und andere temporäre Daten werden nach Ablauf ihrer Gültigkeit automatisch gelöscht.",
        "es": "Los datos se almacenan mientras su cuenta esté activa. Los tokens de verificación, la caché del tiempo y otros datos temporales se eliminan automáticamente al expirar.",
        "ru": "Данные хранятся до тех пор, пока ваша учётная запись активна. Токены верификации, кэш погоды и другие временные данные автоматически удаляются по истечении срока действия.",
        "zh": "数据在您的账户有效期间持续存储。验证令牌、天气缓存及其他临时数据在过期后将自动删除。",
        "ja": "データはアカウントがアクティブな間、保存されます。認証トークン、天気キャッシュ、その他の一時データは有効期限が切れると自動的に削除されます。",
        "ko": "데이터는 계정이 활성 상태인 동안 저장됩니다. 인증 토큰, 날씨 캐시 및 기타 임시 데이터는 만료 후 자동으로 삭제됩니다.",
        "hi": "डेटा तब तक संग्रहीत रहता है जब तक आपका खाता सक्रिय है। सत्यापन टोकन, मौसम कैश और अन्य अस्थायी डेटा समाप्त होने के बाद स्वचालित रूप से हटा दिए जाते हैं।"
      }
    ]
  },
  {
    "h": {
      "id": "5. Hak Anda",
      "en": "5. Your Rights",
      "ar": "5. حقوقك",
      "fr": "5. Vos droits",
      "de": "5. Ihre Rechte",
      "es": "5. Sus derechos",
      "ru": "5. Ваши права",
      "zh": "5. 您的权利",
      "ja": "5. お客様の権利",
      "ko": "5. 귀하의 권리",
      "hi": "5. आपके अधिकार"
    },
    "p": [
      {
        "id": "Anda dapat melihat dan mengubah data akun di halaman Profil, menyalin catatan, menghapus foto jurnal, mematikan pengingat, dan menghapus akun kapan saja.",
        "en": "You can view and edit your account data on the Profile page, copy notes, delete journal photos, turn off reminders, and delete your account at any time.",
        "ar": "يمكنك عرض بيانات حسابك وتعديلها في صفحة الملف الشخصي، ونسخ الملاحظات، وحذف صور المجلة، وإيقاف تشغيل التذكيرات، وحذف حسابك في أي وقت.",
        "fr": "Vous pouvez consulter et modifier les données de votre compte sur la page Profil, copier des notes, supprimer des photos du journal, désactiver les rappels et supprimer votre compte à tout moment.",
        "de": "Sie können Ihre Kontodaten auf der Profilseite einsehen und bearbeiten, Notizen kopieren, Journalfotos löschen, Erinnerungen deaktivieren und Ihr Konto jederzeit löschen.",
        "es": "Puede ver y editar los datos de su cuenta en la página de Perfil, copiar notas, eliminar fotos del diario, desactivar recordatorios y eliminar su cuenta en cualquier momento.",
        "ru": "Вы можете просматривать и редактировать данные своей учётной записи на странице Профиля, копировать заметки, удалять фотографии из журнала, отключать напоминания и удалять учётную запись в любое время.",
        "zh": "您可以在个人资料页面查看和编辑账户数据、复制笔记、删除日记照片、关闭提醒，并随时删除账户。",
        "ja": "プロフィールページでアカウントデータの閲覧・編集、メモのコピー、日記写真の削除、リマインダーのオフ、いつでもアカウントの削除が可能です。",
        "ko": "프로필 페이지에서 계정 데이터를 조회 및 편집하고, 메모를 복사하고, 일기 사진을 삭제하고, 알림을 끄고, 언제든지 계정을 삭제할 수 있습니다.",
        "hi": "आप प्रोफ़ाइल पृष्ठ पर अपने खाते का डेटा देख और संपादित कर सकते हैं, नोट्स कॉपी कर सकते हैं, जर्नल फ़ोटो हटा सकते हैं, अनुस्मारक बंद कर सकते हैं और कभी भी खाता हटा सकते हैं।"
      }
    ]
  },
  {
    "h": {
      "id": "6. Menghapus akun dan data Anda",
      "en": "6. Deleting Your Account and Data",
      "ar": "6. حذف حسابك وبياناتك",
      "fr": "6. Suppression de votre compte et de vos données",
      "de": "6. Löschen Ihres Kontos und Ihrer Daten",
      "es": "6. Eliminación de su cuenta y datos",
      "ru": "6. Удаление вашей учётной записи и данных",
      "zh": "6. 删除您的账户和数据",
      "ja": "6. アカウントとデータの削除",
      "ko": "6. 계정 및 데이터 삭제",
      "hi": "6. आपका खाता और डेटा हटाना"
    },
    "p": [
      {
        "id": "Di dalam aplikasi: masuk, buka Profil → Hapus Akun, masukkan kata sandi, lalu konfirmasi. Akun beserta seluruh data ibadah, foto, pengingat, dan sesi Anda dihapus permanen seketika dan tidak dapat dipulihkan.",
        "en": "In the app: sign in, open Profile → Delete Account, enter your password, then confirm. Your account along with all worship data, photos, reminders, and sessions will be permanently deleted instantly and cannot be recovered.",
        "ar": "داخل التطبيق: سجّل الدخول، افتح الملف الشخصي ← حذف الحساب، أدخل كلمة المرور، ثم أكّد. سيُحذف حسابك مع جميع بيانات العبادة والصور والتذكيرات والجلسات بشكل دائم وفوري ولا يمكن استعادته.",
        "fr": "Dans l'application : connectez-vous, ouvrez Profil → Supprimer le compte, saisissez votre mot de passe, puis confirmez. Votre compte ainsi que toutes les données d'adoration, photos, rappels et sessions seront supprimés définitivement et instantanément, sans possibilité de récupération.",
        "de": "In der App: Melden Sie sich an, öffnen Sie Profil → Konto löschen, geben Sie Ihr Passwort ein und bestätigen Sie. Ihr Konto sowie alle Gottesdienst-Daten, Fotos, Erinnerungen und Sitzungen werden sofort dauerhaft gelöscht und können nicht wiederhergestellt werden.",
        "es": "En la aplicación: inicie sesión, abra Perfil → Eliminar cuenta, ingrese su contraseña y confirme. Su cuenta junto con todos los datos de adoración, fotos, recordatorios y sesiones se eliminará de forma permanente e instantánea y no podrá recuperarse.",
        "ru": "В приложении: войдите в систему, откройте Профиль → Удалить аккаунт, введите пароль и подтвердите. Ваш аккаунт вместе со всеми данными об ибадате, фотографиями, напоминаниями и сеансами будет немедленно удалён безвозвратно.",
        "zh": "在应用内：登录，打开个人资料 → 删除账户，输入密码，然后确认。您的账户及所有礼拜数据、照片、提醒和会话将立即被永久删除，且无法恢复。",
        "ja": "アプリ内で：ログインし、プロフィール → アカウントを削除を開き、パスワードを入力して確認してください。アカウントとすべての礼拝データ、写真、リマインダー、セッションは即座に完全に削除され、復元することはできません。",
        "ko": "앱에서: 로그인 후 프로필 → 계정 삭제를 열고 비밀번호를 입력한 다음 확인하세요. 계정과 모든 예배 데이터, 사진, 알림 및 세션이 즉시 영구적으로 삭제되며 복구할 수 없습니다.",
        "hi": "ऐप में: साइन इन करें, प्रोफ़ाइल → खाता हटाएं खोलें, पासवर्ड दर्ज करें, फिर पुष्टि करें। आपका खाता सभी इबादत डेटा, फ़ोटो, रिमाइंडर और सत्रों के साथ तुरंत स्थायी रूप से हटा दिया जाएगा और इसे पुनर्प्राप्त नहीं किया जा सकता।"
      },
      {
        "id": "Melalui email: kirim permintaan dari alamat email akun Anda ke {contact} dengan subjek \"Hapus akun\". Kami memproses permintaan dalam waktu 30 hari.",
        "en": "Via email: send a request from your account's email address to {contact} with the subject \"Delete account\". We process requests within 30 days.",
        "ar": "عبر البريد الإلكتروني: أرسل طلبًا من عنوان البريد الإلكتروني المرتبط بحسابك إلى {contact} بعنوان \"حذف الحساب\". نعالج الطلبات في غضون 30 يومًا.",
        "fr": "Par e-mail : envoyez une demande depuis l'adresse e-mail de votre compte à {contact} avec l'objet « Supprimer le compte ». Nous traitons les demandes dans un délai de 30 jours.",
        "de": "Per E-Mail: Senden Sie eine Anfrage von der E-Mail-Adresse Ihres Kontos an {contact} mit dem Betreff „Konto löschen\". Wir bearbeiten Anfragen innerhalb von 30 Tagen.",
        "es": "Por correo electrónico: envíe una solicitud desde la dirección de correo electrónico de su cuenta a {contact} con el asunto \"Eliminar cuenta\". Procesamos las solicitudes en un plazo de 30 días.",
        "ru": "По электронной почте: отправьте запрос с адреса электронной почты вашего аккаунта на {contact} с темой «Удалить аккаунт». Мы обрабатываем запросы в течение 30 дней.",
        "zh": "通过电子邮件：从您账户的电子邮件地址发送请求至 {contact}，主题为\"删除账户\"。我们将在30天内处理请求。",
        "ja": "メールで：アカウントのメールアドレスから {contact} に「アカウントを削除」という件名でリクエストを送信してください。リクエストは30日以内に処理されます。",
        "ko": "이메일로: 계정 이메일 주소에서 {contact}로 \"계정 삭제\"라는 제목으로 요청을 보내세요. 요청은 30일 이내에 처리됩니다.",
        "hi": "ईमेल के माध्यम से: अपने खाते के ईमेल पते से {contact} पर \"खाता हटाएं\" विषय के साथ अनुरोध भेजें। हम 30 दिनों के भीतर अनुरोधों को संसाधित करते हैं।"
      }
    ]
  },
  {
    "h": {
      "id": "7. Anak-anak",
      "en": "7. Children",
      "ar": "7. الأطفال",
      "fr": "7. Enfants",
      "de": "7. Kinder",
      "es": "7. Niños",
      "ru": "7. Дети",
      "zh": "7. 儿童",
      "ja": "7. 子ども",
      "ko": "7. 어린이",
      "hi": "7. बच्चे"
    },
    "p": [
      {
        "id": "Manasik tidak ditujukan untuk anak di bawah 13 tahun dan kami tidak sengaja mengumpulkan data dari mereka. Jika Anda yakin anak Anda telah membuat akun, hubungi kami untuk menghapusnya.",
        "en": "Manasik is not intended for children under 13 years of age and we do not knowingly collect data from them. If you believe your child has created an account, please contact us to have it deleted.",
        "ar": "لا يُوجَّه تطبيق مناسك للأطفال دون سن 13 عامًا، ولا نجمع بياناتهم عن قصد. إذا كنت تعتقد أن طفلك قد أنشأ حسابًا، فتواصل معنا لحذفه.",
        "fr": "Manasik n'est pas destiné aux enfants de moins de 13 ans et nous ne collectons pas sciemment de données les concernant. Si vous pensez que votre enfant a créé un compte, contactez-nous pour le supprimer.",
        "de": "Manasik richtet sich nicht an Kinder unter 13 Jahren, und wir erfassen wissentlich keine Daten von ihnen. Wenn Sie glauben, dass Ihr Kind ein Konto erstellt hat, kontaktieren Sie uns, um es zu löschen.",
        "es": "Manasik no está destinado a menores de 13 años y no recopilamos datos de ellos de forma intencionada. Si cree que su hijo ha creado una cuenta, contáctenos para eliminarla.",
        "ru": "Manasik не предназначен для детей младше 13 лет, и мы намеренно не собираем их данные. Если вы считаете, что ваш ребёнок создал аккаунт, свяжитесь с нами для его удаления.",
        "zh": "Manasik 不面向13岁以下的儿童，我们不会故意收集他们的数据。如果您认为您的孩子创建了账户，请联系我们将其删除。",
        "ja": "Manasikは13歳未満の子どもを対象としておらず、意図的に彼らのデータを収集することはありません。お子さまがアカウントを作成したと思われる場合は、削除のためにご連絡ください。",
        "ko": "Manasik은 13세 미만의 어린이를 대상으로 하지 않으며, 의도적으로 그들의 데이터를 수집하지 않습니다. 자녀가 계정을 만들었다고 생각되시면 삭제를 위해 저희에게 연락해 주세요.",
        "hi": "Manasik 13 वर्ष से कम उम्र के बच्चों के लिए नहीं है और हम जानबूझकर उनसे डेटा एकत्र नहीं करते। यदि आपको लगता है कि आपके बच्चे ने खाता बनाया है, तो इसे हटाने के लिए हमसे संपर्क करें।"
      }
    ]
  },
  {
    "h": {
      "id": "8. Perubahan kebijakan",
      "en": "8. Policy Changes",
      "ar": "8. تغييرات السياسة",
      "fr": "8. Modifications de la politique",
      "de": "8. Änderungen der Richtlinie",
      "es": "8. Cambios en la política",
      "ru": "8. Изменения политики",
      "zh": "8. 政策变更",
      "ja": "8. ポリシーの変更",
      "ko": "8. 정책 변경",
      "hi": "8. नीति में परिवर्तन"
    },
    "p": [
      {
        "id": "Kami dapat memperbarui kebijakan ini dari waktu ke waktu. Versi terbaru selalu tersedia di {domain}/privacy beserta tanggal pembaruannya.",
        "en": "We may update this policy from time to time. The latest version is always available at {domain}/privacy along with its update date.",
        "ar": "قد نُحدِّث هذه السياسة من وقت لآخر. تتوفر أحدث نسخة دائمًا على {domain}/privacy مع تاريخ تحديثها.",
        "fr": "Nous pouvons mettre à jour cette politique de temps à autre. La dernière version est toujours disponible sur {domain}/privacy avec sa date de mise à jour.",
        "de": "Wir können diese Richtlinie von Zeit zu Zeit aktualisieren. Die neueste Version ist stets unter {domain}/privacy zusammen mit dem Aktualisierungsdatum verfügbar.",
        "es": "Podemos actualizar esta política de vez en cuando. La versión más reciente siempre está disponible en {domain}/privacy junto con su fecha de actualización.",
        "ru": "Мы можем периодически обновлять эту политику. Последняя версия всегда доступна по адресу {domain}/privacy вместе с датой обновления.",
        "zh": "我们可能会不时更新本政策。最新版本始终可在 {domain}/privacy 上查阅，并附有更新日期。",
        "ja": "本ポリシーは随時更新される場合があります。最新版は常に {domain}/privacy で更新日とともに確認できます。",
        "ko": "저희는 수시로 이 정책을 업데이트할 수 있습니다. 최신 버전은 항상 {domain}/privacy에서 업데이트 날짜와 함께 확인하실 수 있습니다.",
        "hi": "हम समय-समय पर इस नीति को अपडेट कर सकते हैं। नवीनतम संस्करण हमेशा {domain}/privacy पर अपनी अपडेट तिथि के साथ उपलब्ध रहता है।"
      }
    ]
  },
  {
    "h": {
      "id": "9. Kontak",
      "en": "9. Contact",
      "ar": "9. التواصل",
      "fr": "9. Contact",
      "de": "9. Kontakt",
      "es": "9. Contacto",
      "ru": "9. Контакты",
      "zh": "9. 联系方式",
      "ja": "9. お問い合わせ",
      "ko": "9. 연락처",
      "hi": "9. संपर्क"
    },
    "p": [
      {
        "id": "Pertanyaan tentang privasi atau permintaan data: {contact}.",
        "en": "Questions about privacy or data requests: {contact}.",
        "ar": "استفسارات حول الخصوصية أو طلبات البيانات: {contact}.",
        "fr": "Questions sur la confidentialité ou demandes de données : {contact}.",
        "de": "Fragen zum Datenschutz oder Datenanfragen: {contact}.",
        "es": "Preguntas sobre privacidad o solicitudes de datos: {contact}.",
        "ru": "Вопросы о конфиденциальности или запросы данных: {contact}.",
        "zh": "有关隐私问题或数据请求，请联系：{contact}。",
        "ja": "プライバシーに関するご質問またはデータリクエスト：{contact}。",
        "ko": "개인정보 관련 문의 또는 데이터 요청: {contact}.",
        "hi": "गोपनीयता संबंधी प्रश्न या डेटा अनुरोध: {contact}।"
      }
    ]
  }
];

export const DELETE_UI = {
  "title": {
    "id": "Hapus Akun",
    "en": "Delete Account",
    "ar": "حذف الحساب",
    "fr": "Supprimer le compte",
    "de": "Konto löschen",
    "es": "Eliminar cuenta",
    "ru": "Удалить аккаунт",
    "zh": "删除账户",
    "ja": "アカウントを削除",
    "ko": "계정 삭제",
    "hi": "खाता हटाएं"
  },
  "desc": {
    "id": "Menghapus akun akan menghapus permanen profil, progres manasik, catatan, jurnal foto, statistik, dan pengingat Anda. Tindakan ini tidak dapat dibatalkan.",
    "en": "Deleting your account will permanently remove your profile, manasik progress, notes, photo journal, statistics, and reminders. This action cannot be undone.",
    "ar": "حذف حسابك سيؤدي إلى إزالة ملفك الشخصي وتقدم المناسك والملاحظات ومجلة الصور والإحصاءات والتذكيرات بشكل نهائي. لا يمكن التراجع عن هذا الإجراء.",
    "fr": "La suppression de votre compte effacera définitivement votre profil, votre progression des manasik, vos notes, votre journal photo, vos statistiques et vos rappels. Cette action est irréversible.",
    "de": "Das Löschen Ihres Kontos entfernt dauerhaft Ihr Profil, Ihren Manasik-Fortschritt, Notizen, Fototagebuch, Statistiken und Erinnerungen. Diese Aktion kann nicht rückgängig gemacht werden.",
    "es": "Eliminar tu cuenta borrará de forma permanente tu perfil, el progreso de los manasik, notas, diario fotográfico, estadísticas y recordatorios. Esta acción no se puede deshacer.",
    "ru": "Удаление аккаунта навсегда уничтожит ваш профиль, прогресс манасик, заметки, фотодневник, статистику и напоминания. Это действие невозможно отменить.",
    "zh": "删除账户将永久移除您的个人资料、朝觐功课（manasik）进度、笔记、照片日记、统计数据和提醒。此操作无法撤销。",
    "ja": "アカウントを削除すると、プロフィール、マナーシク（manasik）の進捗、メモ、フォトジャーナル、統計、およびリマインダーが完全に削除されます。この操作は元に戻せません。",
    "ko": "계정을 삭제하면 프로필, 마나식(manasik) 진행 상황, 메모, 사진 일지, 통계 및 알림이 영구적으로 삭제됩니다. 이 작업은 취소할 수 없습니다.",
    "hi": "खाता हटाने से आपका प्रोफ़ाइल, मनासिक (manasik) प्रगति, नोट्स, फ़ोटो जर्नल, आँकड़े और अनुस्मारक स्थायी रूप से हटा दिए जाएंगे। यह क्रिया पूर्ववत नहीं की जा सकती।"
  },
  "button": {
    "id": "Hapus akun saya",
    "en": "Delete my account",
    "ar": "حذف حسابي",
    "fr": "Supprimer mon compte",
    "de": "Mein Konto löschen",
    "es": "Eliminar mi cuenta",
    "ru": "Удалить мой аккаунт",
    "zh": "删除我的账户",
    "ja": "アカウントを削除する",
    "ko": "내 계정 삭제",
    "hi": "मेरा खाता हटाएं"
  },
  "dialogTitle": {
    "id": "Konfirmasi penghapusan akun",
    "en": "Confirm account deletion",
    "ar": "تأكيد حذف الحساب",
    "fr": "Confirmer la suppression du compte",
    "de": "Kontolöschung bestätigen",
    "es": "Confirmar eliminación de cuenta",
    "ru": "Подтвердить удаление аккаунта",
    "zh": "确认删除账户",
    "ja": "アカウント削除の確認",
    "ko": "계정 삭제 확인",
    "hi": "खाता हटाने की पुष्टि करें"
  },
  "dialogDesc": {
    "id": "Untuk melanjutkan, masukkan kata sandi Anda dan ketik kata konfirmasi.",
    "en": "To continue, enter your password and type the confirmation word.",
    "ar": "للمتابعة، أدخل كلمة المرور الخاصة بك واكتب كلمة التأكيد.",
    "fr": "Pour continuer, saisissez votre mot de passe et tapez le mot de confirmation.",
    "de": "Um fortzufahren, geben Sie Ihr Passwort ein und tippen Sie das Bestätigungswort.",
    "es": "Para continuar, ingrese su contraseña y escriba la palabra de confirmación.",
    "ru": "Чтобы продолжить, введите пароль и слово подтверждения.",
    "zh": "要继续，请输入您的密码并键入确认词。",
    "ja": "続行するには、パスワードを入力し、確認ワードを入力してください。",
    "ko": "계속하려면 비밀번호를 입력하고 확인 단어를 입력하세요.",
    "hi": "जारी रखने के लिए, अपना पासवर्ड दर्ज करें और पुष्टि शब्द टाइप करें।"
  },
  "passwordLabel": {
    "id": "Kata sandi",
    "en": "Password",
    "ar": "كلمة المرور",
    "fr": "Mot de passe",
    "de": "Passwort",
    "es": "Contraseña",
    "ru": "Пароль",
    "zh": "密码",
    "ja": "パスワード",
    "ko": "비밀번호",
    "hi": "पासवर्ड"
  },
  "confirmLabel": {
    "id": "Ketik {word} untuk mengonfirmasi",
    "en": "Type {word} to confirm",
    "ar": "اكتب {word} للتأكيد",
    "fr": "Tapez {word} pour confirmer",
    "de": "Tippen Sie {word} zur Bestätigung",
    "es": "Escriba {word} para confirmar",
    "ru": "Введите {word} для подтверждения",
    "zh": "输入 {word} 以确认",
    "ja": "確認のために {word} と入力してください",
    "ko": "확인을 위해 {word}을(를) 입력하세요",
    "hi": "पुष्टि करने के लिए {word} टाइप करें"
  },
  "confirmWord": {
    "id": "HAPUS",
    "en": "DELETE",
    "ar": "حذف",
    "fr": "SUPPRIMER",
    "de": "LÖSCHEN",
    "es": "ELIMINAR",
    "ru": "УДАЛИТЬ",
    "zh": "删除",
    "ja": "削除",
    "ko": "삭제",
    "hi": "हटाएं"
  },
  "cancel": {
    "id": "Batal",
    "en": "Cancel",
    "ar": "إلغاء",
    "fr": "Annuler",
    "de": "Abbrechen",
    "es": "Cancelar",
    "ru": "Отмена",
    "zh": "取消",
    "ja": "キャンセル",
    "ko": "취소",
    "hi": "रद्द करें"
  },
  "confirm": {
    "id": "Hapus permanen",
    "en": "Delete permanently",
    "ar": "حذف نهائي",
    "fr": "Supprimer définitivement",
    "de": "Dauerhaft löschen",
    "es": "Eliminar permanentemente",
    "ru": "Удалить навсегда",
    "zh": "永久删除",
    "ja": "完全に削除する",
    "ko": "영구 삭제",
    "hi": "स्थायी रूप से हटाएं"
  },
  "deleting": {
    "id": "Menghapus…",
    "en": "Deleting…",
    "ar": "جارٍ الحذف…",
    "fr": "Suppression…",
    "de": "Wird gelöscht…",
    "es": "Eliminando…",
    "ru": "Удаление…",
    "zh": "正在删除…",
    "ja": "削除中…",
    "ko": "삭제 중…",
    "hi": "हटाया जा रहा है…"
  },
  "wrongPassword": {
    "id": "Kata sandi salah.",
    "en": "Incorrect password.",
    "ar": "كلمة المرور غير صحيحة.",
    "fr": "Mot de passe incorrect.",
    "de": "Falsches Passwort.",
    "es": "Contraseña incorrecta.",
    "ru": "Неверный пароль.",
    "zh": "密码错误。",
    "ja": "パスワードが違います。",
    "ko": "비밀번호가 틀립니다.",
    "hi": "गलत पासवर्ड।"
  },
  "adminBlocked": {
    "id": "Akun admin tidak dapat dihapus dari sini.",
    "en": "An admin account cannot be deleted from here.",
    "ar": "لا يمكن حذف حساب المشرف من هنا.",
    "fr": "Un compte administrateur ne peut pas être supprimé d'ici.",
    "de": "Ein Administratorkonto kann von hier nicht gelöscht werden.",
    "es": "Una cuenta de administrador no puede eliminarse desde aquí.",
    "ru": "Учётная запись администратора не может быть удалена отсюда.",
    "zh": "管理员账户无法在此处删除。",
    "ja": "管理者アカウントはここから削除できません。",
    "ko": "관리자 계정은 여기서 삭제할 수 없습니다.",
    "hi": "एडमिन अकाउंट को यहाँ से हटाया नहीं जा सकता।"
  },
  "deleted": {
    "id": "Akun Anda telah dihapus. Terima kasih telah menggunakan Manasik.",
    "en": "Your account has been deleted. Thank you for using Manasik.",
    "ar": "تم حذف حسابك. شكراً لاستخدامك تطبيق مناسك.",
    "fr": "Votre compte a été supprimé. Merci d'avoir utilisé Manasik.",
    "de": "Ihr Konto wurde gelöscht. Vielen Dank, dass Sie Manasik verwendet haben.",
    "es": "Su cuenta ha sido eliminada. Gracias por usar Manasik.",
    "ru": "Ваша учётная запись удалена. Спасибо за использование Manasik.",
    "zh": "您的账户已被删除。感谢您使用 Manasik。",
    "ja": "アカウントが削除されました。Manasikをご利用いただきありがとうございました。",
    "ko": "계정이 삭제되었습니다. Manasik을 이용해 주셔서 감사합니다.",
    "hi": "आपका अकाउंट हटा दिया गया है। Manasik का उपयोग करने के लिए शुक्रिया।"
  },
  "policyLink": {
    "id": "Baca Kebijakan Privasi",
    "en": "Read the Privacy Policy",
    "ar": "اقرأ سياسة الخصوصية",
    "fr": "Lire la Politique de confidentialité",
    "de": "Datenschutzrichtlinie lesen",
    "es": "Leer la Política de privacidad",
    "ru": "Читать Политику конфиденциальности",
    "zh": "阅读隐私政策",
    "ja": "プライバシーポリシーを読む",
    "ko": "개인정보 처리방침 읽기",
    "hi": "गोपनीयता नीति पढ़ें"
  }
};

export const LEGAL_UI = {
  "privacyLink": {
    "id": "Kebijakan Privasi",
    "en": "Privacy Policy",
    "ar": "سياسة الخصوصية",
    "fr": "Politique de confidentialité",
    "de": "Datenschutzrichtlinie",
    "es": "Política de privacidad",
    "ru": "Политика конфиденциальности",
    "zh": "隐私政策",
    "ja": "プライバシーポリシー",
    "ko": "개인정보 처리방침",
    "hi": "गोपनीयता नीति"
  },
  "deleteAccountLink": {
    "id": "Cara menghapus akun",
    "en": "How to delete your account",
    "ar": "كيفية حذف حسابك",
    "fr": "Comment supprimer votre compte",
    "de": "So löschen Sie Ihr Konto",
    "es": "Cómo eliminar tu cuenta",
    "ru": "Как удалить аккаунт",
    "zh": "如何删除您的账户",
    "ja": "アカウントの削除方法",
    "ko": "계정 삭제 방법",
    "hi": "अपना खाता कैसे हटाएं"
  },
  "installLink": {
    "id": "Pasang aplikasi",
    "en": "Install the app",
    "ar": "تثبيت التطبيق",
    "fr": "Installer l'application",
    "de": "App installieren",
    "es": "Instalar la aplicación",
    "ru": "Установить приложение",
    "zh": "安装应用程序",
    "ja": "アプリをインストール",
    "ko": "앱 설치",
    "hi": "ऐप इंस्टॉल करें"
  },
  "footer": {
    "id": "© {year} Manasik · {domain}",
    "en": "© {year} Manasik · {domain}",
    "ar": "© {year} Manasik · {domain}",
    "fr": "© {year} Manasik · {domain}",
    "de": "© {year} Manasik · {domain}",
    "es": "© {year} Manasik · {domain}",
    "ru": "© {year} Manasik · {domain}",
    "zh": "© {year} Manasik · {domain}",
    "ja": "© {year} Manasik · {domain}",
    "ko": "© {year} Manasik · {domain}",
    "hi": "© {year} Manasik · {domain}"
  }
};
